var React = require('react');

function Filter (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"interior","d":"M4.45,4.66,10,11V21l4-2V11l5.55-6.34A1,1,0,0,0,18.8,3H5.2A1,1,0,0,0,4.45,4.66Z"}));
}

Filter.defaultProps = {"className":"icon line","width":"48","height":"48","id":"filter","viewBox":"0 0 24 24"};

module.exports = Filter;

Filter.default = Filter;
